import { MasterLayout } from 'layout/master/main';
import { CompanyHeader } from 'module/companyHeader/main';
import { CompanyText } from 'module/companyText/main';
import { CompanyLocation } from 'module/companyLocation/main';
import { CompanyBenefits } from 'module/companyBenefits/main';
import { CompanyImages } from 'module/companyImages/main';
import { CompanyValueList } from 'module/companyValueList/main';
import { CompanyProspect } from 'module/companyProspect/main';
import { CompanyMission } from 'module/companyMission/main';
import { CompanyImageBox } from 'module/companyImageBox/main';
import { CompanyImageMain } from 'module/companyImageMain/main';
import { CompanyFacts } from 'module/companyFacts/main';
import { CompanyCardSlider } from 'module/companyCardSlider/main';
import { CompanyJobsList } from 'module/companyJobsList/main';
import { RelatedCompaniesList } from 'module/relatedCompaniesList/main';
import { StaticMap } from 'module/staticMap/main';
import { CompanyRecruiter } from 'module/companyRecruiter/main';
import { CompanyTestimonialList } from 'module/companyTestimonialList/main';
import { AppController } from 'app/controller';
import { TIME_SNACKBAR_MEDIUM } from 'app/timings';
import { MAIL_NEVER, MAIL_WEEKLY } from 'app/mailSubscriptionInterval';
import { app } from 'app/app';
import { user } from 'app/user';
import { userWatchlist } from 'app/userWatchlist';
import { userCompanyFollow } from 'app/userCompanyFollow';
import { buildUrl } from 'util/url';
import { trackGa4, sendPageView } from 'util/googleAnalytics';
import { CompanyRecruiterInquiryModal } from 'module/companyRecruiterInquiryModal/main';
import { log } from '@karriereat/action-logger/dist/log';
import './styles.scss';

class CompanyIndex extends AppController {
    domBindings() {
        return {
            page: '.c-companyIndex',
            companyImages: '.m-companyImages',
            companyHeader: '.m-companyHeader',
            companyText: '.m-companyText',
            companyLocation: '.m-companyLocation',
            companyBenefits: '.m-companyBenefits',
            companyJobsList: '.m-companyJobsList',
            companyFacts: '.m-companyFacts',
            companyCardSlider: '.m-companyCardSlider',
            staticMap: '.m-staticMap',
            companyRecruiter: '.m-companyRecruiter',
            companyValueList: '.m-companyValueList',
            companyProspect: '.m-companyProspect',
            companyMission: '.m-companyMission',
            companyImageBox: '.m-companyImageBox',
            companyImageMain: '.m-companyImageMain',
            relatedCompaniesList: '.m-relatedCompaniesList',
            companyTestimonialList: '.m-companyTestimonialList',
            companyRecruiterInquiryModal: '.m-companyRecruiterInquiryModal',
        };
    }

    getPropsFromDom() {
        return {
            preview: this.dom.page.getAttribute('data-preview'),
            slug: this.dom.page.getAttribute('data-slug'),
            companyAlarmNotificationInterval:
                parseInt(this.dom.page.getAttribute('data-companyalarmnotificationinterval'), 10),
            companyId: this.dom.page.getAttribute('data-company-id'),
            isTypeEmployerPage: this.dom.page.getAttribute('data-employer-page') === '1' ?? false,
            isTypeEmployerPagePlus: this.dom.page.getAttribute('data-employer-page-plus') === '1' ?? false,
        };
    }

    ready() {
        if (this.companyImages) {
            this.layout.lightBox.updateProps({ mediaItems: this.companyImages.props.images });
        }
        if (this.companyImageMain) {
            this.layout.lightBox.updateProps({ mediaItems: this.companyImageMain.props.images });
        }
        if (this.companyImages || this.companyImageMain) {
            this.initHistoryApi();
        }

        if (this.props.isTypeEmployerPage) {
            trackGa4({
                event: 'company_view',
                view_type: 'Standalone',
                product_type: 'employer.page',
                company_id: this.props.companyId ?? null,
            });
        } else if (this.props.isTypeEmployerPagePlus) {
            trackGa4({
                event: 'company_view',
                view_type: 'Standalone',
                product_type: 'employer.page Plus',
                company_id: this.props.companyId ?? null,
            });
        }
    }

    onPopState(state) {
        if (!state) return; // hashbang fix
        if (this.layout.lightBox.props.active !== false) {
            this.layout.lightBox.closeLightBox();
        } else {
            this.layout.lightBox.openMediaItem(this.layout.lightBox.props.lastSrc);
        }
        sendPageView();
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        this.companyHeader = new CompanyHeader(this.dom.companyHeader);

        if (this.dom.companyImages) {
            this.companyImages = new CompanyImages(this.dom.companyImages);
        }
        if (this.dom.companyImageBox) {
            this.companyImageBox = new CompanyImageBox(this.dom.companyImageBox);
        }
        if (this.dom.companyImageMain) {
            this.companyImageMain = new CompanyImageMain(this.dom.companyImageMain);
        }
        if (this.dom.companyText) {
            this.companyText = new CompanyText(this.dom.companyText);
        }
        if (this.dom.companyLocation) {
            this.companyLocation = new CompanyLocation(this.dom.companyLocation);
        }
        if (this.dom.companyBenefits) {
            this.companyBenefits = new CompanyBenefits(this.dom.companyBenefits);
        }
        if (this.dom.companyJobsList) {
            this.companyJobsList = new CompanyJobsList(this.dom.companyJobsList);
        }
        if (this.dom.companyFacts) {
            this.companyFacts = new CompanyFacts(this.dom.companyFacts);
        }
        if (this.dom.companyRecruiter) {
            this.companyRecruiter = new CompanyRecruiter(this.dom.companyRecruiter);
        }
        if (this.dom.companyCardSlider) {
            this.companyCardSlider = new CompanyCardSlider(this.dom.companyCardSlider);
        }
        if (this.dom.companyValueList) {
            this.companyValueList = new CompanyValueList(this.dom.companyValueList);
        }
        if (this.dom.companyMission) {
            this.companyMission = new CompanyMission(this.dom.companyMission);
        }
        if (this.dom.companyProspect) {
            this.companyProspect = new CompanyProspect(this.dom.companyProspect);
        }
        if (this.dom.relatedCompaniesList) {
            this.relatedCompaniesList = new RelatedCompaniesList(this.dom.relatedCompaniesList);
        }
        if (this.dom.companyTestimonialList) {
            this.companyTestimonialList = new CompanyTestimonialList(this.dom.companyTestimonialList);
        }
        if (this.dom.staticMap) {
            this.staticMap = new StaticMap(this.dom.staticMap);
        }
        if (this.dom.companyRecruiterInquiryModal) {
            this.companyRecruiterInquiryModal = new CompanyRecruiterInquiryModal(this.dom.companyRecruiterInquiryModal);
        }
    }

    subEvents() {
        if (this.companyRecruiterInquiryModal) {
            this.companyRecruiterInquiryModal.loadCaptcha();
        }

        if (this.companyImages || this.companyImageMain) {
            this.layout.events.on('pushState', () => {
                this.pushState(this.getProps(), document.title, window.location.href, false);
            });
        }

        if (this.companyImages) {
            this.companyImages.events.on('openMediaItem', (context) => {
                this.layout.lightBox.openMediaItemViaClick(context.arguments[0]);
            });
        }

        if (this.companyImageBox) {
            this.companyImageBox.events.on('openMediaItem', (context) => {
                this.layout.lightBox.openMediaItemViaClick(context.arguments[0]);
            });
        }

        if (this.companyImageMain) {
            this.companyImageMain.events.on('openMediaItem', (context) => {
                this.layout.lightBox.openMediaItemViaClick(context.arguments[0]);
            });
        }

        if (this.companyJobsList) {
            this.companyJobsList.events.on(
                'changedLocation',
                (searchRequest) => {
                    window.location.href = buildUrl(`/jobs/${searchRequest.arguments[0].locationSlug}`);
                },
            );
        }
        if (this.companyRecruiter) {
            this.companyRecruiter.events.on('openInquiryModal', (context) => {
                // eslint-disable-next-line prefer-destructuring
                this.companyRecruiterInquiryModal.props = context.arguments[0];
                this.companyRecruiterInquiryModal.updateProps(
                    Object.assign(
                        this.companyRecruiterInquiryModal.getPropsFromDom(),
                        { visible: true, active: true },
                    ),
                    true,
                );
                this.companyRecruiterInquiryModal.loadCaptcha();
                this.layout.addModalStyle(true);
            });
        }

        if (this.companyRecruiterInquiryModal) {
            this.companyRecruiterInquiryModal.events.on('showCompanyRecruiterInquiryToast', () => {
                this.layout.toast.updateProps({
                    active: true,
                    message: 'Deine Nachricht wurde erfolgreich gesendet!',
                    iconSuccess: true,
                    type: 'success',
                }, true);
                this.layout.toast.slideIn();
            });

            this.companyRecruiterInquiryModal.events.on('removeModalStyle', () => {
                this.layout.removeModalStyle(true);
            });

            this.companyRecruiterInquiryModal.events.on('addModalStyle', () => {
                this.layout.addModalStyle(true);
            });
        }

        if (!user.isLoggedIn()) {
            userWatchlist.events.on('onUnauthorized', (watchlistObject) => {
                this.layout.openLoginModal(watchlistObject.arguments[0].watchlistObject.state, true);
            });
            userCompanyFollow.events.on('onUnauthorized', (followObject) => {
                this.layout.openLoginModal(followObject.arguments[0].companyFollowObject.state, true);
            });
        } else {
            userCompanyFollow.events.on('onAddJob', () => {
                let snackbarText;
                if (this.props.companyAlarmNotificationInterval === MAIL_WEEKLY) {
                    snackbarText = 'Ab sofort erhältst du wöchentlich neue Jobs dieser Firma per E-Mail.';
                } else {
                    snackbarText = 'Ab sofort erhältst du täglich neue Jobs dieser Firma per E-Mail.';
                }

                this.layout.showSnackbar(
                    TIME_SNACKBAR_MEDIUM,
                    false,
                    false,
                    false,
                    false,
                    snackbarText,
                    false,
                    '/settings/notifications#c-notificationIndex-companyalarm',
                    false,
                    'Anpassen',
                );
            });
            userCompanyFollow.events.on('onRemoveJob', () => {
                if (this.props.companyAlarmNotificationInterval !== MAIL_NEVER) {
                    this.layout.showSnackbar(
                        TIME_SNACKBAR_MEDIUM,
                        false,
                        false,
                        false,
                        false,
                        'Du erhältst ab sofort keine Jobs dieser Firma mehr per E-Mail.',
                        true,
                        false,
                        false,
                        false,
                    );
                }
            });
            userCompanyFollow.events.on('onFollowError', (error) => {
                [].forEach.call(error.arguments[0].errors, (err) => {
                    if (err.meta.company_follow_max_limit) {
                        this.layout.showSnackbar(
                            TIME_SNACKBAR_MEDIUM,
                            false,
                            false,
                            false,
                            false,
                            'Oje, du hast das Maximum schon erreicht! Um dieser Firma zu folgen, '
                            + 'entfolge einer anderen Firma.',
                            false,
                            '/companyalarm?openAccordion=true',
                            false,
                            'Zum Firmen-Alarm ',
                        );
                    }
                });
            });
        }

        this.layout.lightBox.events.on('image-view', () => {
            log('company-image-view', {
                slug: this.props.slug,
            });
        });
    }
}

app.boot(CompanyIndex);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(CompanyIndex);
    });

    module.hot.accept(() => {});
}
